// @ts-nocheck
/**
 * 情報員NPC定義
 * 各地域のファンド詳細画面で登場する情報員キャラクター
 */

export const INFORMANTS = {
  karuno: {
    id: 'karuno',
    name: 'カルノ',
    region: '血呪の峠',
    appearance: '日焼け、汗っかき',
    personality: '熱血、大雑把',
    icon: '🔥',
    quotes: {
      greeting: '熱い情報だぜ！',
      good: '火山が噴きそうだ！チャンスだぜ！',
      bad: 'ちょっと静かだな...様子見か',
      neutral: '今日は普通だな。大きな動きはなさそうだ',
    },
  },
  shellna: {
    id: 'shellna',
    name: 'シェルナ',
    region: '深海アクアレギナ',
    appearance: '青髪、貝殻アクセ',
    personality: '無口、ミステリアス',
    icon: '💧',
    quotes: {
      greeting: '...深海が動いてる',
      good: '...大きな波が来る',
      bad: '...静かすぎる',
      neutral: '...いつも通り',
    },
  },
  fine: {
    id: 'fine',
    name: 'フィーネ',
    region: 'ルミナリス聖域',
    appearance: '白いローブ、穏やか',
    personality: '丁寧すぎる、天然',
    icon: '✨',
    quotes: {
      greeting: '光の導きがございます',
      good: '聖なる光が満ちております',
      bad: '少々曇り気味でございますね',
      neutral: '平穏な日々が続いております',
    },
  },
  grim: {
    id: 'grim',
    name: 'グリム',
    region: '黒呪の大陸',
    appearance: '黒フード、顔見えない',
    personality: '不吉、皮肉屋',
    icon: '🌙',
    quotes: {
      greeting: '嫌な予感がするね...',
      good: '闇が濃くなってる...いい兆候だ',
      bad: '静かすぎる...何か企んでるな',
      neutral: 'まあ、普通だな...つまらん',
    },
  },
  poron: {
    id: 'poron',
    name: 'ポロン',
    region: '虹羽密林',
    appearance: '小柄、葉っぱまみれ',
    personality: 'のんびり、マイペース',
    icon: '🌿',
    quotes: {
      greeting: 'んー、なんか変だなあ',
      good: '森がざわざわしてるよー',
      bad: 'みんなお昼寝中かなー',
      neutral: 'いつも通りだねー',
    },
  },
  techno: {
    id: 'techno',
    name: 'テクノ',
    region: '時空の狭間',
    appearance: 'ゴーグル、白衣',
    personality: '早口、オタク',
    icon: '⚙️',
    quotes: {
      greeting: '時空歪曲率が上昇中なのだよ！',
      good: '異常値検出！これはすごいことになるのだ！',
      bad: '観測値は平常...退屈なのだ',
      neutral: '特筆すべきデータはないのだ',
    },
  },
};

/**
 * 情報員IDから情報員情報を取得
 */
export function getInformant(informantId) {
  return INFORMANTS[informantId] || null;
}

/**
 * 価格変動率に応じた情報員のコメントを取得
 * @param {string} informantId - 情報員ID
 * @param {number} priceChange - 価格変動率（%）
 * @returns {string} コメント
 */
export function getInformantComment(informantId, priceChange) {
  const informant = INFORMANTS[informantId];
  if (!informant) return '';

  if (priceChange >= 5) {
    return informant.quotes.good;
  } else if (priceChange <= -5) {
    return informant.quotes.bad;
  } else {
    return informant.quotes.neutral;
  }
}

/**
 * 全情報員一覧を取得
 */
export function getAllInformants() {
  return Object.values(INFORMANTS);
}
